module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI1IiB2aWV3Qm94PSIwIDAgOCA1IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMC43MTAwNTEgMS43MUwzLjMwMDA1IDQuM0MzLjY5MDA1IDQuNjkgNC4zMjAwNSA0LjY5IDQuNzEwMDUgNC4zTDcuMzAwMDUgMS43MUM3LjkzMDA1IDEuMDggNy40ODAwNSAwIDYuNTkwMDUgMEgxLjQxMDA1QzAuNTIwMDUxIDAgMC4wODAwNTE1IDEuMDggMC43MTAwNTEgMS43MVoiIGZpbGw9IiMxRDMzNTQiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/Down.svg
// module id = rRKW
// module chunks = 0